import Reflux from 'reflux'

export default Reflux.createActions(['executeQuery','updateControlAllowEdit','updateControlVisible','updateControlLabel','updateControlShowDecimal','updateControlProperty',
	'writeControl','buttonOk','dsAllowEdit','switchTabPage','bindStyle','setButtonStyle','setTextStyle','setContainerStyle','selectRecords',
	'refreshPlugin','updateGroupCollapseState','updateDropDownContent']);
	


// WEBPACK FOOTER //
// ./src/actions/CmdTypeActions.js